export const PROTOCOL_VERSION = 1;

export type OutboundType =
  | 'apptor:boot'
  | 'apptor:theme.update'
  | 'apptor:theme.preview'
  | 'apptor:context.update'
  | 'apptor:open'
  | 'apptor:close';

export type InboundType =
  | 'apptor:ready'
  | 'apptor:unread'
  | 'apptor:open'
  | 'apptor:close'
  | 'apptor:user-message'
  | 'apptor:ai-message'
  | 'apptor:entity-click';

export function sendToIframe(
  iframe: HTMLIFrameElement,
  type: OutboundType,
  payload: unknown,
  origin: string
): void {
  const win = iframe.contentWindow;
  if (!win) return;
  win.postMessage({ type, version: PROTOCOL_VERSION, payload }, origin);
}

export function makeIframeListener(
  expectedOrigin: string,
  handler: (msg: { type: InboundType; payload?: unknown; version: number }) => void
) {
  return (e: MessageEvent) => {
    if (e.origin !== expectedOrigin) return;
    const data = (e.data || {}) as { type?: InboundType; version?: number; payload?: unknown };
    if (data.version !== PROTOCOL_VERSION || !data.type) return;
    handler({ type: data.type, payload: data.payload, version: data.version });
  };
}
